<template>
  <div class="user-button-update" @click="update">
    内容を更新
  </div>
</template>

<script>
import MixinResultHandler from '@/components/MixinResultHandler'

export default {
  mixins: [ MixinResultHandler ],
  methods: {
    update: async function () {
      const result = await this.$store.dispatch('user/updateUser')
      this.showSnackAndMove(result)
    }
  }
}
</script>

<style lang="scss" scoped>
.user-button-update {
  @include button-ol-warning;
}
</style>
